export default "__VITE_ASSET__CZA$Ewy5__"